import { Input } from '@trackman/web-shared-components';
import { Select } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { useStores } from 'index';

const recordingInfo = [
  { label: 'Video ID', value: 'Video ID' },
  { label: 'Video URL', value: 'Video URL' },
];

export const RecordingSettings = observer(() => {
  const es = useStores().trackmanEventsEditorStore;

  const videoSettingsChange = useCallback(
    (event) => {
      es.isVideoIdSelected = event.target.value === 'Video ID';
      es.isVideoIdSelected && delete es.eventItem.videoUrl;
      !es.isVideoIdSelected && delete es.eventItem.videoId;
      es.imagePreview = '';
      es.uploadedImageAccepted = false;
      es.eventItem.imageUrl = '';
      delete es.eventItem.imageData;
    },
    [es]
  );

  return (
    <div className='admin-edit-section'>
      <h2>Recording URL*</h2>
      <div className='inputs-container recording-settings'>
        <Select
          label=''
          value={es.eventItem.videoId || es.isVideoIdSelected ? 'Video ID' : 'Video URL'}
          className='narrow-select'
          required
          onChange={(event) => videoSettingsChange(event)}
          selectOptions={recordingInfo.map((info) => {
            return {
              label: info.label,
              value: info.value,
            };
          })}
        />
        {es.eventItem.videoId || es.isVideoIdSelected ? (
          <Input
            label='Video ID'
            value={es.eventItem.videoId ?? ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => (es.eventItem.videoId = e.currentTarget.value)}
          />
        ) : (
          <Input
            label='Video URL'
            value={es.eventItem.videoUrl ?? ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => (es.eventItem.videoUrl = e.currentTarget.value)}
          />
        )}
      </div>
    </div>
  );
});

export default RecordingSettings;
